import { gateway } from "../../../gateway";

export const getClients = async ({
  page = 1,
  pageSize = 10,
  orderBy, // ASC | DESC
  orderField, // createdAt | clientCompanyName
  search, // valor de búsqueda
  filterBy, // clientName | email | phone | type | address
  token,
  status,
}) => {
  try {
    let url = `/clients?page=${page}&pagesize=${pageSize}`;

    if (orderBy && orderField) {
      url += `&ordertype=${orderBy}&order=${orderField}`;
    }

    if (search && filterBy) {
      url += `&filterBy=${filterBy}&filterValue=${search.trim()}`;
    }

    if (status) {
      url += `&status=${status}`;
    }

    const res = await gateway.get(url, {
      headers: {
        Authorization: `${token}`,
      },
    });

    const response = res.data?.data || res.data || {};

    return {
      items: response.items ?? [],
      page: response.page ?? page,
      pageSize: response.pageSize ?? pageSize,
      totalItems: response.totalItems ?? 0,
      totalPages: response.totalPages ?? 0,
    };
  } catch (error) {
    throw error;
  }
};

export const getClientByUidApi = async (uid) => {
  const token = sessionStorage.getItem("token");
  const response = await gateway.get(`/clients/${uid}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data?.data || response.data;
};
